import React, { useState } from "react";
import { AiFillQuestionCircle, AiOutlineClose } from "react-icons/ai";
import { Modal } from "antd";
import "./InstructionButton.css";
import {
  ruleImage1,
  ruleImage2,
  ruleImage3,
  ruleImage4,
  ruleImage5,
} from "./ruleImages.js";
import { VscZoomIn, VscZoomOut } from "react-icons/vsc";
import { IconIMUMRulesImageModal } from "../Layout/Icons.jsx";

const RuleCard = ({ title, children, onModalChange, image }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [zoom, setZoom] = useState(0.5);
  const maxZoom = 2;
  const minZoom = 0.5;

  console.log(zoom, "zoom");
  const showModal = () => {
    setIsModalVisible(true);
    onModalChange(true);
  };

  const handleOk = () => {
    setIsModalVisible(false);
    handleDownload();
    onModalChange(false);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    onModalChange(false);
  };

  const handleZoomIn = () => {
    if (zoom < maxZoom) {
      setZoom((prevZoom) => prevZoom * 2);
    }
  };

  const handleZoomOut = () => {
    if (zoom > minZoom) {
      setZoom((prevZoom) => prevZoom / 2);
    }
  };

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = image;
    link.download = title;
    link.click();
  };

  return (
    <>
      <div className="itemContainer">
        <div className="ruleCardItemContainer d-flex flex-row align-items-center">
          <p className="ruleCardTitle">{title}</p>
          {image && (
            <div
              onClick={() => {
                !isModalVisible ? showModal() : handleCancel();
              }}
            >
              <IconIMUMRulesImageModal className="iconImageModal ml-1" />
            </div>
          )}
        </div>
        <div style={{ padding: 10 }}>{children}</div>
      </div>
      <Modal
        title={title}
        open={isModalVisible}
        onOk={handleOk}
        width={600}
        okText="Parsisiųsti"
        onCancel={handleCancel}
        className="imageModal"
      >
        <div>
          <div className="d-flex justify-content-end">
            <div className="mr-1" onClick={handleZoomIn}>
              <VscZoomIn className="cursor-pointer" size={18} color="#8C8C8C" />
            </div>
            <div onClick={handleZoomOut}>
              <VscZoomOut
                className="cursor-pointer"
                size={18}
                color="#8C8C8C"
              />
            </div>
          </div>
          <div className="ruleCardOverflowAuto">
            <img
              src={image}
              alt="Rule"
              className="ruleCardRuleImage"
              style={{ width: `${zoom * 100}%` }}
            />
          </div>
        </div>
      </Modal>
    </>
  );
};

const InstructionButton = (props) => {
  const [showModal, setShowModal] = useState(false);
  const [isImageModalShowing, setIsImageModalShowing] = useState(false);

  const handleModalChange = (isShowing) => {
    setIsImageModalShowing(isShowing);
  };

  return (
    <div className="buttonContainer">
      <button className="helpButton" onClick={() => setShowModal(true)}>
        <AiFillQuestionCircle color="#FFFFFF" size={17} />
      </button>

      {showModal && (
        <>
          {!isImageModalShowing && (
            <div
              className="modalBackground"
              onClick={() => setShowModal(false)}
            />
          )}

          <div className="modalContainer">
            <div className="modalContent" onClick={(e) => e.stopPropagation()}>
              <div className="modalHeader">
                <div className="modalTitle">
                  <AiFillQuestionCircle color="#42ADE2" size={20} />
                  <p className="modalTitleText">Pagalba</p>
                </div>
                <AiOutlineClose
                  color="#00000080"
                  cursor="pointer"
                  onClick={() => setShowModal(false)}
                />
              </div>
              <div className="modalInnerContainer">
                <RuleCard
                  title="Pigiausio konkrento kainos skaičiavimo taisyklė"
                  onModalChange={handleModalChange}
                  image={ruleImage1}
                >
                  <p>
                    Pigiausio konkrento kainos skaičiavimo taisyklė. Vykdomas
                    kainų iš IMUM sinchronizacijos metu.
                  </p>
                  <br />
                  <ol>
                    <li>
                      Tai yra proceso pradžia. Čia skaičiuojama konkurentų kainų
                      mediana.
                    </li>
                    <li>
                      {
                        "Randami konkurentai, kurie atitinka sąlygas: price > 0.7 * mediana AND price < 1.3 * mediana AND price > 0.7 * old_price AND price < 1.3 * old_price (kur price - konkurento kaina, old_price - BigBox kaina). Jei randama konkurentų, tada tęsiama toliau. Jei atsakymas yra “Ne”, grįžtama atgal į proceso pradžią."
                      }
                    </li>
                    <li>
                      Iš atrinktų konkurentų, parenkamas su mažiausia kaina.
                    </li>
                    <li>
                      Pritaikyti kainą: Po to, kai pasirenkama mažiausia kaina,
                      ji yra pritaikoma.
                    </li>
                    <li>
                      Užbaigti procesą: Po to, kai kaina yra pritaikoma,
                      procesas baigiamas.
                    </li>
                  </ol>
                </RuleCard>
                <RuleCard
                  title="Keisti prekės kainą taisyklė"
                  onModalChange={handleModalChange}
                  image={ruleImage2}
                >
                  <ol>
                    <li>
                      Keisti prekės kainą: Tai yra proceso pradžia. Čia
                      nusprendžiama, ar keisti prekės kainą.
                    </li>
                    <li>
                      Keičiama kaina yra padidinta daugiau nei +30% arba
                      pamazinta daugiau nei -30% pokytčio nuo pradinės kainos:
                      Jei kaina keičiama, tada patikrinama, ar keičiama kaina
                      yra padidinta daugiau nei 30% arba sumažinta daugiau nei
                      30% nuo pradinės kainos. Jei atsakymas yra “Ne”, grįžtama
                      atgal į proceso pradžią. Jei atsakymas yra “Taip”, tęsiama
                      toliau.
                    </li>
                    <li>
                      Prašyti patvirtinti kainą: Jei kaina yra padidinta arba
                      sumažinta daugiau nei 30%, reikia patvirtinti naują kainą.
                    </li>
                    <li>
                      Užbaigti tikrinimą: Po to, kai nauja kaina patvirtinama,
                      tikrinimas baigiamas.
                    </li>
                  </ol>
                </RuleCard>
                <RuleCard
                  title="Eksportuoti prekių kainas taisyklė"
                  onModalChange={handleModalChange}
                  image={ruleImage3}
                >
                  <ol>
                    <li>
                      Eksportuoti prekių kainas: Tai yra proceso pradžia. Čia
                      nusprendžiama, ar eksportuoti prekių kainas.
                    </li>
                    <li>
                      Eksportuojamų prekių kaina yra daugiau nei +/- 15% nuo
                      pradinės kainos: Jei kaina keičiama, tada patikrinama, ar
                      eksportuojamų prekių kaina yra daugiau nei 15% arba mažiau
                      nei 15% nuo pradinės kainos. Jei atsakymas yra “Ne”,
                      grįžtama atgal į proceso pradžią. Jei atsakymas yra
                      “Taip”, tęsiama toliau.
                    </li>
                    <li>
                      Pradėti patvirtinti kainą: Jei kaina yra padidinta arba
                      sumažinta daugiau nei 15%, reikia pradėti patvirtinti
                      naują kainą.
                    </li>
                    <li>
                      Užbaigti tikrinimą: Po to, kai nauja kaina patvirtinama,
                      tikrinimas baigiamas
                    </li>
                  </ol>
                </RuleCard>
                <RuleCard
                  title="Kainos eksportuojamos į “PIM/Akeneo” taisyklė"
                  onModalChange={handleModalChange}
                  image={ruleImage4}
                >
                  <p>
                    Kainos eksportavimas į PIM/Akeneo taisyklė. Vykdomas prieš
                    keliant kainas į PIM/Akeneo tiek rankiniu būdu, tiek per
                    automatizuotas taisykles.
                  </p>
                  <br />
                  <ol>
                    <li>
                      Kainos eksportuojamos | PIM/Akeneo: Tai yra proceso
                      pradžia. Čia nusprendžiama, ar eksportuoti prekių kainas.
                    </li>
                    <li>
                      {
                        "Paimama eksportuojamo produkto kategorijos leidžiamo nuokrypio procentas. Numatytotji reikšmė 30%. Kaina atitinka sąlygą: price > 0.7 * old_price (0.7, jeigu leistinas nuokrypis 30%): Jei kaina atitinka šią sąlygą, tada tęsiama toliau. Jei atsakymas yra “Ne”, grįžtama atgal į proceso pradžią."
                      }
                    </li>
                    <li>
                      Neeksportuoti kainos: Jei kaina neatitinka sąlygos, tada
                      kaina neeksportuojama.
                    </li>
                    <li>
                      Eksportuoti kainą: Jei kaina atitinka sąlygą, tada kaina
                      eksportuojama.
                    </li>
                  </ol>
                </RuleCard>
                <RuleCard
                  title="Kainos taikymas produktui, prioretizavimo taisyklė"
                  onModalChange={handleModalChange}
                  image={ruleImage5}
                >
                  <p>
                    Kai egzistuoja kelios taisyklės, aukščiausią svarbumą turės
                    taisyklė esanti vėliausiai laiko prasme ir turinti
                    prioriteto žymą. Lentelėje yra pateikiamos variacijos, kaip
                    veikia taisyklių taikymas kai jų yra daugiau nei viena.
                  </p>
                  <br />
                  <p>
                    <b>Kaip pavyzdys, jei turime:</b>
                  </p>
                  <ul>
                    <li>1 taisyklę 10:10, be prioriteto;</li>
                    <li>2 taisyklę 10:10 su prioritetu;</li>
                    <li>3 taisyklę 11:05 su prioritetu;</li>
                    <li>4 taisyklę 12:00 be prioriteto;</li>
                  </ul>
                  <br />
                  <p>
                    Šiuo atveju bus pritaikyta 2 taisyklė, net jei ji yra
                    taikoma anksčiau laiko prasme, tačiau ji turi prioriteto
                    žymą.
                  </p>
                  <br />
                  <p>Čia yra pradedama automatinė kainodara.</p>
                </RuleCard>
                <RuleCard
                  title="Inicijuoti taisyklę “B” tik atlikus taisyklę “A”"
                  onModalChange={handleModalChange}
                >
                  <p>
                    Taisyklė „B“ gali būti inicijuojama tik po to, kai buvo
                    atlikta taisyklė „A“. Tai reiškia, kad taisyklė „A“ yra
                    sąlyga, kuri turi būti įvykdyta pirmiau, kad būtų galima
                    pereiti prie taisyklės „B“.
                  </p>
                  <br />
                  <p>
                    Šis nustatymas yra parenkamas kuriant arba redaguojant
                    taisyklę “Run after selected rule” laukelyje.
                  </p>
                </RuleCard>
                <RuleCard
                  title="Specialios žymės kūrimo ir dubliavimo į Technorama IMUM taisyklė"
                  onModalChange={handleModalChange}
                >
                  <p>
                    <strong>Dubliaivimas į Technorama IMUM:</strong>
                  </p>
                  <ol>
                    <li>Pažymėkite „Duplicate tag to TR IMUM“ kuriant žymę.</li>
                    <li>
                      Sistema automatiškai sukurs tą pačią žymę Technorama IMUM.
                    </li>
                  </ol>
                  <p>
                    <strong>Pastaba:</strong> Dubliaivimo funkcija veikia tik
                    jei pažymėta atitinkama parinktis.
                  </p>
                </RuleCard>
                <RuleCard
                  title="PIM kanalo kainos išjungimas"
                  onModalChange={handleModalChange}
                >
                  <p>
                    Norint išjungti PIM kanalo kainą, pažymėjus nustatymą
                    "Disable channel price scope", pirmiausia patikrinama, ar
                    prekė neturi konkurento. Jei konkurento nėra, sąlyga laikoma
                    patenkinta ir kanalo kainos aprėptis yra išjungiama ir
                    įjungiama sinchronizacija iš BIGBOX.LT (ne BIGBOX.LT
                    kanale).
                  </p>
                </RuleCard>
                <RuleCard
                  title="IMUM sinchronizacijos laikai"
                  onModalChange={handleModalChange}
                >
                  <p>
                    09:30 vykdoma „IMUM Priority“ prekių sinchronizacija. Jos metu apdorojamos tik prekės, turinčios „Priority“ žymą, bei joms taikomos taisyklės. Po šios sinchronizacijos pradedamas visų likusių prekių duomenų atnaujinimas iš „IMUM“ ir joms skirtų taisyklių vykdymas.
                  </p>
                  <br />
                  <p>
                    16:00 vykdoma antroji „Priority“ prekių sinchronizacija kartu su jų taisyklių pritaikymu. Pakartotinė ne „Priority“ prekių sinchronizacija šiuo metu nevykdoma.

                  </p>
                </RuleCard>
              </div>
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default InstructionButton;
